import type { PriceAlertConditionType } from './types';

export function isPriceCondition(condition: PriceAlertConditionType): boolean {
  return condition === 'PRICE_ABOVE' || condition === 'PRICE_BELOW';
}

/**
 * UI stores all target values as cents (Number).
 *  - PRICE_* condition: cents → fraction of 1 (55¢ → 0.55)
 *  - VOLUME_* / BOOK_DEPTH_* / WHALE_TRADE: cents → USD (5_000_000¢ → $50K)
 */
export function targetValueFromForm(uiCents: number): number {
  return Math.round(uiCents) / 100;
}

export function priceTargetCents(targetValue: number): number {
  return Math.round(targetValue * 100);
}
